export default __webpack_public_path__ + "static/media/PR.FREQUENCY.FIVE_ACTIVITIES_IN_WEEK_ACHIEVED.03cfa8a3.jpg";